<div style="position: relative;">
  <i class="fas fa-times-circle mt-2 mr-2" style="color: black;position: absolute;right: 0px;font-size: 20px;"></i>
  <div class="p-3">
    <div class="alert p-0" role="alert">
      <div class="row">
        <div class="col-2">
          <i class="fas fa-exclamation-circle mr-2" style="font-size: 30px;color:  #920808;"></i>
        </div>
        <div class="col-10">
          <h1 class="m-0" style="color: #009845;">¡Lo sentimos!</h1>
          <h3 class="m-0">El servicio que está tratando de acceder no está disponible</h3>
        </div>
      </div>
    </div>
    <div class="ml-3">
      <p>Puede intentar nuevamente más tarde o ponerse en contacto con nuestro Centro de Ayuda.</p>
      <p>Para mayor información comuniquese al <span style="color:#009845;font-weight: bold;">1 700 800 700*</span></p>
      <p>Escríbanos al <span style="color:#009845;font-weight: bold;">info@bmachala.com</span></p>
    </div>
    <div class="text-right">
      <button class="btn" style="background-color: #009845;color:white;">Ir al Inicio
        &nbsp;&nbsp;&nbsp;<i class="fas fa-arrow-right"></i></button>
    </div>
  </div>
</div>
